import { Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import { Refresh as RefreshIcon, ShowChart as ShowChartIcon, Visibility as VisibilityIcon } from '@mui/icons-material';
import { C, SectionHeader, fmtNum, fmtPct, sectionCardSx, sectorDisplayName, tableBodyCellSx, tableHeadCellSx } from './shared';

export default function SideRail({ t, lang, summary, history, historyError }) {
  return (
    <Stack spacing={2} sx={{ flex: 0.9 }}>
      <Paper elevation={0} sx={{ ...sectionCardSx }}>
        <SectionHeader icon={<ShowChartIcon sx={{ fontSize: 16 }} />} title={t('bottomingFlow.sectors.title')} />
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={tableHeadCellSx}>{t('bottomingFlow.sectors.sector')}</TableCell>
                <TableCell sx={tableHeadCellSx} align="right">{t('bottomingFlow.sectors.accumulation')}</TableCell>
                <TableCell sx={tableHeadCellSx} align="right">{t('bottomingFlow.sectors.baseCompression')}</TableCell>
                <TableCell sx={tableHeadCellSx} align="right">{t('bottomingFlow.sectors.tightRange')}</TableCell>
                <TableCell sx={tableHeadCellSx} align="right">{t('bottomingFlow.sectors.spotlight')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {(summary?.top_sectors || []).map((row) => (
                <TableRow key={row.sector}>
                  <TableCell sx={{ ...tableBodyCellSx, color: C.ink, fontWeight: 700 }}>{sectorDisplayName(row, lang)}</TableCell>
                  <TableCell sx={tableBodyCellSx} align="right">{fmtPct(row.accumulation_pct, 0)}</TableCell>
                  <TableCell sx={tableBodyCellSx} align="right">{fmtPct(row.base_compression_pct, 0)}</TableCell>
                  <TableCell sx={tableBodyCellSx} align="right">{fmtPct(row.tight_range_pct, 0)}</TableCell>
                  <TableCell sx={tableBodyCellSx} align="right">{fmtPct(row.spotlight_pct, 0)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      <Paper elevation={0} sx={{ ...sectionCardSx }}>
        <SectionHeader icon={<RefreshIcon sx={{ fontSize: 16 }} />} title={t('bottomingFlow.history.title')} />
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell sx={tableHeadCellSx}>{t('bottomingFlow.history.date')}</TableCell>
                <TableCell sx={tableHeadCellSx} align="right">{t('bottomingFlow.history.avg')}</TableCell>
                <TableCell sx={tableHeadCellSx} align="right">{t('bottomingFlow.history.shakeout')}</TableCell>
                <TableCell sx={tableHeadCellSx} align="right">{t('bottomingFlow.history.reclaim')}</TableCell>
                <TableCell sx={tableHeadCellSx} align="right">{t('bottomingFlow.history.breakdown')}</TableCell>
                <TableCell sx={tableHeadCellSx} align="right">{t('bottomingFlow.history.reliability')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {history.length ? history.map((row) => (
                <TableRow key={row.score_date}>
                  <TableCell sx={{ ...tableBodyCellSx, color: C.ink }}>{row.score_date}</TableCell>
                  <TableCell sx={tableBodyCellSx} align="right">{fmtNum(row.avg_score, 1)}</TableCell>
                  <TableCell sx={tableBodyCellSx} align="right">{row.shakeout_count || 0}</TableCell>
                  <TableCell sx={tableBodyCellSx} align="right">{row.reclaim_count || 0}</TableCell>
                  <TableCell sx={tableBodyCellSx} align="right">{row.breakdown_count || 0}</TableCell>
                  <TableCell sx={{ ...tableBodyCellSx, color: C.ink, fontWeight: 700 }} align="right">{fmtNum(row.reliability_score, 1)}</TableCell>
                </TableRow>
              )) : (
                <TableRow>
                  <TableCell colSpan={6} sx={{ ...tableBodyCellSx, py: 3.5, textAlign: 'center', color: C.inkSoft }}>
                    {historyError || t('bottomingFlow.history.empty')}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>

      <Paper elevation={0} sx={{ ...sectionCardSx, p: 2.1 }}>
        <Stack direction="row" spacing={1} alignItems="center">
          <VisibilityIcon sx={{ color: C.slate }} />
          <Typography sx={{ fontSize: '0.82rem', fontWeight: 800, color: C.ink }}>
            {t('bottomingFlow.guide.title')}
          </Typography>
        </Stack>
        <Typography sx={{ mt: 1, fontSize: '0.79rem', color: C.inkMid, lineHeight: 1.75 }}>
          {t('bottomingFlow.guide.body')}
        </Typography>
      </Paper>
    </Stack>
  );
}
